import React from 'react';
import style from './index.module.scss';
import { useKVConfig } from '@/hooks';

const PolicyPage: React.FC = () => {
  const { value } = useKVConfig(`CUSTOM_PAGE_policy`, true);

  return (
    <div
      className={style.container}
      dangerouslySetInnerHTML={{ __html: value! }}
    ></div>
  );
};

export default PolicyPage;
